import styled from "styled-components";

export const SidebarWrapper = styled.div`
  position: fixed;
  width: 270px;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 100;
  background-color: var(--white);
  border-left: 1px solid var(--border);
  border-right: 1px solid var(--border);
  transition: 0.3s all;
  z-index: 100;
  body.rtl & {
    left: unset;
    right: 0;
  }
  .logo {
    width: 200px;
  }
  .sidebar-item {
    cursor: pointer;
    position: relative;
    padding: 10px 20px;
    transition: all ease-in-out 0.3s;
    font-size: 15px;
    color: var(--text);
    border-color: var(--themeColor2);
    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 0.25rem;
      background-color: var(--themeColor2);
      transition: all 0.3s ease;
      opacity: 0;
    }
    body.rtl &::before {
      right: auto;
      left: 0;
    }
    svg {
      width: 24px;
    }
    &:hover,
    &.active {
      &::before {
        opacity: 1;
      }
      svg {
        [stroke] {
          stroke: var(--themeColor);
        }
        [fill] {
          fill: var(--themeColor);
        }
      }
      span {
        font-weight: 700;
      }
    }
  }
  .logo-container {
    padding: 29.5px;
    border: 1px solid var(--border);
  }
  .sidebar-list {
    height: calc(100vh - 93px);
    /* height: 100%; */
    overflow-y: auto !important;
  }
  .close {
    width: 20px;
  }

  @media (max-width: 992px) {
    width: 0;
    opacity: 0;
    pointer-events: none;
    &.open {
      width: 270px;
      opacity: 1;
      pointer-events: all;
    }
    .logo {
      width: 165px;
    }
  }
`;
